<template>
  <div class="call-test-results-dialog mt-3" v-if="amReady">
    <dg-select-field
        :control="control"
        :field_span="24"
        :label_span="24"
        :options="statusList"
        :translateLabel="false"
        :translateLabels="false"
        @amUpdated="setVendorDestinationStatus"
        field_mark="required"
        label="Status"
        name="status"
        placeholder="Select Status"
        rules="required"></dg-select-field>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import panelMixin from "@/app/portals/cpanel/mixins/util";

export default {
  mixins: [fieldController, panelMixin],
  props: {
    broadcast: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      control: this,
      amReady: true,
      statusList: ($store.getters['user-state/isUserMrt'])? $store.state['voip-testing-panel-state'].callTestStatusesMrt : $store.state['voip-testing-panel-state'].callTestStatuses,
    };
  },
  methods: {
    setVendorDestinationStatus(command, params) {
      let data = {broadcast_id: this.broadcast.id, status_id: this.dataModel.status}
      this.panelMixin_createVendorDestinationStatus({data}, () => {
        this.$emit('closeModel', this.dataModel.status)
      })
    }
  }
}
</script>
